import { useTranslation } from 'react-i18next'
import type { AdminHealth } from './adminTypes'

type Props = {
  health: AdminHealth | null
}

function statusEmoji(status: AdminHealth['status'] | undefined): string {
  if (status === 'error') return '🔴'
  if (status === 'warn') return '🟡'
  return '🟢'
}

export default function AdminHealthCard({ health }: Props) {
  const { t } = useTranslation()
  if (!health) return null

  const counters = (health.metrics?.counters as Record<string, number>) ?? {}

  return (
    <section className="vc-admin-card vc-admin-health">
      <header className="vc-admin-health__head">
        <h3>{t('admin.systemHealth')}</h3>
        <span className={`vc-admin-health__status vc-admin-health__status--${health.status}`}>
          {statusEmoji(health.status)} {t(`admin.health.${health.status}`)}
        </span>
      </header>
      <div className="vc-admin-inline-stats">
        <span>
          {t('admin.webhooksTotal')}: <strong>{counters.stripe_webhooks_total ?? 0}</strong>
        </span>
        <span>
          {t('admin.refundFailures')}: <strong>{counters.refund_failures_total ?? 0}</strong>
        </span>
        <span>
          {t('admin.escrowReleased')}: <strong>{counters.escrow_released_total ?? 0}</strong>
        </span>
      </div>
      {health.reasons.length > 0 ? (
        <p className="vc-admin-muted">{health.reasons.map((r) => t(`admin.healthReason.${r}`)).join(' · ')}</p>
      ) : null}
    </section>
  )
}
